import type { Filters } from './filters';
import type { SearchResultsState } from './searchResults';
import type { HotelPageState } from './hotelPage';
import type { DirectHotelPrices } from './directHotelPrices';
import type { MapState } from './map';
import type { BookingState } from './bookingPage';

// Root state
export interface AccommodationState {
    searchResults: SearchResultsState;
    hotelPage: HotelPageState;
    filters: Filters;
    directPrices: DirectHotelPrices;
    map: MapState;
    booking: BookingState;
}

export * from './common';
export * from './directHotelPrices';
export * from './filters';
export * from './hotelPage';
export * from './bookingPage';
export * from './map';
export * from './searchResults';
export * from './utils';
export * from './unleash';
